import './Team.css'
import React from "react";
import pastorPaul from './images/pastor.png';
import { Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet';

const Team = () => {
    return (
        <div>
            <Helmet>
                <title>New Beginnings Church of The Nazarene | Ministry Team</title>
            </Helmet>
            <h1 className="page-header">Ministry Team</h1>
            <Row>
                <Col md={3}>
                    <img src={pastorPaul} alt='Pastor Paul' className="centered-image" />
                </Col>
                <Col md={9}>
                    <h3>Pastor Paul Thornhill</h3>
                    <p>Pastor Paul Thornhill is an experienced pastor and church planter serving in the Royersford, Limerick, Pottstown and Pottsgrove areas.  Pastor Paul  is labeled as a pastor of encouragement to those he serves as well to those he meets in the ministry area.  He believes strongly in the Power of Prayer and the Word of God.  </p>
                </Col>
            </Row>
        </div>
    );
}

export default Team;